<div class="container-fluid">
  <div class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="mb-0 d-flex align-items-center">
          <button
            mat-icon-button
            (click)="goBack()"
            class="me-1"
            [matTooltip]="'COMMON.BACK' | translate"
            matTooltipPosition="above"
          >
            <mat-icon class="text-primary">arrow_back</mat-icon>
          </button>
          {{
            showErrorDetails
              ? ("UPLOAD_LOGS.ERROR_DETAILS" | translate)
              : ("UPLOAD_LOGS.TITLE" | translate)
          }}
        </h5>

        <button
          *ngIf="showErrorDetails"
          mat-stroked-button
          color="primary"
          (click)="backToHistory()"
        >
          <mat-icon>arrow_back</mat-icon>
          {{ "UPLOAD_LOGS.BACK_TO_HISTORY" | translate }}
        </button>
      </div>
    </div>

    <div class="card-body">
      <!-- Alert Messages -->
      <p *ngIf="form['error'] == false && form['message']">
        <app-ncs-alert [message]="form['message']" type="success" />
      </p>
      <p *ngIf="form['error'] == true && form['message']">
        <app-ncs-alert [message]="form['message']" type="danger" />
      </p>

      <!-- UPLOAD HISTORY TABLE -->
      <div *ngIf="!showErrorDetails">
        <div class="mb-3">
          <button mat-stroked-button color="warn" (click)="deleteAllSelectedLogs()">
            {{ "UPLOAD_LOGS.DELETE_SELECTED" | translate }}
          </button>
        </div>

        <div class="table-container">
          <div class="table-responsive table-scrollable">
            <table class="table table-hover table-bordered table-sticky-header">
              <thead>
                <tr>
                  <th class="text-center">
                    <mat-checkbox
                      color="primary"
                      [(ngModel)]="masterSelectedLogs"
                      (change)="selectAllLogs()"
                    ></mat-checkbox>
                  </th>
                  <th class="text-center">{{ "UPLOAD_LOGS.TABLE.SNO" | translate }}</th>
                  <th>{{ "UPLOAD_LOGS.TABLE.FILE_NAME" | translate }}</th>
                  <th>{{ "UPLOAD_LOGS.TABLE.DATE" | translate }}</th>
                  <th>{{ "UPLOAD_LOGS.TABLE.TOTAL_ROWS" | translate }}</th>
                  <th>{{ "UPLOAD_LOGS.TABLE.SUCCESS" | translate }}</th>
                  <th>{{ "UPLOAD_LOGS.TABLE.ERRORS" | translate }}</th>
                  <th>{{ "UPLOAD_LOGS.TABLE.STATUS" | translate }}</th>
                  <th>{{ "UPLOAD_LOGS.TABLE.ACTION" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let log of uploadLogs; let i = index">
                  <td class="text-center">
                    <mat-checkbox
                      color="primary"
                      [(ngModel)]="log.selected"
                      (change)="checkIfAllLogsSelected()"
                    ></mat-checkbox>
                  </td>
                  <td class="text-center">{{ pageIndex(i) }}</td>
                  <td>{{ log.fileName }}</td>
                  <td>{{ log.createdDatetime | date: "dd MMM yyyy, hh:mm a" }}</td>
                  <td>{{ log.totalRows }}</td>
                  <td>
                    <span class="badge bg-success-subtle text-success border">
                      {{ log.successRows }}
                    </span>
                  </td>
                  <td>
                    <span class="badge bg-danger-subtle text-danger border">
                      {{ log.errorRows }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span
                      class="status-badge"
                      [ngClass]="{
                        'status-success': log.status === 'Completed',
                        'status-warning': log.status === 'Completed with Errors',
                        'status-failed': log.status === 'Failed',
                        'status-pending': log.status === 'Pending'
                      }"
                    >
                      {{ log.status }}
                    </span>
                  </td>
                  <td>
                    <div class="d-flex gap-1">
                      <button
                        *ngIf="log.errorRows > 0"
                        mat-stroked-button
                        color="primary"
                        (click)="viewErrors(log.id)"
                      >
                        <mat-icon class="icon-compact">visibility</mat-icon>
                        {{ "UPLOAD_LOGS.ACTIONS.VIEW_ERRORS" | translate }}
                      </button>
                      <button
                        *ngIf="log.errorRows === 0"
                        mat-stroked-button
                        color="primary"
                        disabled
                      >
                        <mat-icon class="icon-compact">visibility_off</mat-icon>
                        {{ "UPLOAD_LOGS.ACTIONS.NO_ERRORS" | translate }}
                      </button>

                      <button
                        class="icon-width icon-center"
                        mat-stroked-button
                        color="warn"
                        (click)="deleteLog(log.id)"
                        [matTooltip]="'COMMON.DELETE' | translate"
                      >
                        <mat-icon class="icon-compact">delete</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="uploadLogs.length === 0" class="text-center py-5">
          <mat-icon class="text-muted" style="font-size: 64px; height: 64px; width: 64px">
            inbox
          </mat-icon>
          <p class="text-muted mt-2">{{ "UPLOAD_LOGS.NO_HISTORY" | translate }}</p>
        </div>

        <app-list-header [$parent]="getSelf()"></app-list-header>
      </div>

      <!-- ERROR DETAILS TABLE -->
      <div *ngIf="showErrorDetails">
        <div class="mb-3">
          <button mat-stroked-button color="warn" (click)="deleteAllSelectedErrors()">
            <mat-icon class="icon-compact me-1">delete</mat-icon>
            {{ "UPLOAD_LOGS.DELETE_SELECTED" | translate }}
          </button>
        </div>

        <div class="table-container">
          <div class="table-responsive table-scrollable">
            <table class="table table-bordered table-hover table-sticky-header">
              <thead>
                <tr>
                  <th class="text-center">
                    <mat-checkbox
                      color="primary"
                      [(ngModel)]="masterSelectedErrors"
                      (change)="selectAllErrors()"
                    ></mat-checkbox>
                  </th>
                  <th class="text-center">{{ "UPLOAD_LOGS.TABLE.SNO" | translate }}</th>
                  <th width="10%">{{ "UPLOAD_LOGS.TABLE.ROW_NO" | translate }}</th>
                  <th width="20%">{{ "UPLOAD_LOGS.TABLE.COLUMN_NAME" | translate }}</th>
                  <th width="22%">{{ "UPLOAD_LOGS.TABLE.VALUE" | translate }}</th>
                  <th width="35%">{{ "UPLOAD_LOGS.TABLE.ERROR_MESSAGE" | translate }}</th>
                  <th width="8%">{{ "UPLOAD_LOGS.TABLE.ACTION" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let error of errorDetails; let i = index">
                  <td class="text-center">
                    <mat-checkbox
                      color="primary"
                      [(ngModel)]="error.selected"
                      (change)="checkIfAllErrorsSelected()"
                    ></mat-checkbox>
                  </td>
                  <td class="text-center">{{ pageIndex(i) }}</td>
                  <td>
                    <span class="badge bg-secondary">{{ error.rowNumber }}</span>
                  </td>
                  <td><strong>{{ error.columnName }}</strong></td>
                  <td><code class="text-muted">{{ error.value || "-" }}</code></td>
                  <td><span class="text-muted">{{ error.errorMessage }}</span></td>
                  <td>
                    <button
                      class="icon-width icon-center"
                      mat-stroked-button
                      color="warn"
                      (click)="deleteErrorDetail(error.id)"
                      [matTooltip]="'COMMON.DELETE' | translate"
                    >
                      <mat-icon class="icon-compact">delete</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="errorDetails.length === 0" class="text-center py-5">
          <mat-icon class="text-success" style="font-size: 64px; height: 64px; width: 64px">
            check_circle
          </mat-icon>
          <p class="text-muted mt-2">{{ "UPLOAD_LOGS.NO_ERRORS" | translate }}</p>
        </div>

        <app-list-header [$parent]="getSelf()"></app-list-header>
      </div>
    </div>
  </div>
</div>